const theme = {
  colors: {
    // '25 Redesign Colors
    white: "#fff",
    black: "#000",
    brightOrange: "#ffa500",
    primaryDark: "#333",
    primaryDarkAccent: "#646464",
    primaryLight: "#fff5ee",
    primaryOrange: "#f9423a",
    disabledButtonFg: "#bfbfbf",
    disabledButtonBg: "#d9d9d9",
    greyLight: "#d3d3d3",
    greyMedium: "#c4c2c2",
    greyDark: "#797979",
    red: "#cc1400",
    green: "#018210",
    testDriveBlue: "#20aff0",
  },
  breakPoints: {
    smallMobile: "375px",
    largeMobile: "475px",
    tablet: "640px",
    tabletLarge: "768px",
    smallDesktop: "900px",
    desktop: "1024px",
    wideScreen: "1600px",
  },
};

export default theme;
